import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { fdPlatformApps } from "../fdModulesData";

const iconMap: Record<string, React.ReactNode> = {
  smartphone: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="6" y="2" width="12" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M10 18h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  navigation: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 2L4 20h16L12 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <circle cx="12" cy="14" r="2" fill="currentColor" />
    </svg>
  ),
  store: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M3 9l2-5h14l2 5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M4 9v10h16V9" stroke="currentColor" strokeWidth="1.5" />
      <path d="M9 19V12h6v7" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  shield: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 2l8 4v6c0 5-3.5 9.5-8 10-4.5-.5-8-5-8-10V6l8-4z" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
};

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

const FdWhatWeProvideSection: React.FC = () => {
  return (
    <section className="wdev-why" aria-labelledby="fd-provide-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="fd-provide-title" className="wdev-section-head__title">
            What We Provide
          </h2>
          <p className="fd-section-lead">
            Dedicated apps for every stakeholder in your food delivery ecosystem — customer,
            driver, merchant, and admin.
          </p>
        </AnimatedSection>

        <div className="wdev-why__grid fd-platform-grid">
          {fdPlatformApps.map((app, index) => (
            <motion.article
              key={app.title}
              className="wdev-why-card fd-platform-card"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
              custom={index}
              variants={cardVariants}
              whileHover={{ y: -6, transition: { duration: 0.25 } }}
            >
              <div className="wdev-why-card__icon">{iconMap[app.icon]}</div>
              <h3 className="fd-platform-card__title">{app.title}</h3>
              <p className="fd-platform-card__desc">{app.description}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FdWhatWeProvideSection;
